/**
 * Normalize and format a date from any of the formats stored in Firestore:
 *  - Firestore Timestamp object (has .toDate())
 *  - Firestore serialized timestamp ({ _seconds, _nanoseconds })
 *  - Milliseconds number (from .toMillis())
 *  - ISO date string
 *  - Date object
 *
 * Returns a locale-formatted date string, or null if unparseable.
 */
export const formatDate = (date) => {
  if (!date) return null;
  try {
    // Firestore Timestamp object
    if (date?.toDate) {
      return date.toDate().toLocaleDateString();
    }
    // Firestore serialized { _seconds } format
    if (date?._seconds) {
      return new Date(date._seconds * 1000).toLocaleDateString();
    }
    // Milliseconds number (e.g. from toMillis())
    if (typeof date === 'number') {
      return new Date(date).toLocaleDateString();
    }
    // String or Date object
    const parsed = new Date(date);
    if (!isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString();
    }
    return null;
  } catch {
    return null;
  }
};
